<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="予約状況照会（一覧）" />
                <v-data-table
                    :headers="headers"
                    :items="desserts"
                    hide-default-footer
                    class="elevation-1"
                    sort-by="play_start"
                    height="535"
                    fixed-header
                >
                <template v-slot:top>
                    <v-form ref="form" lazy-validation>
                        <v-container>
                            <v-row no-gutters>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="予約番号"
                                    maxlength="12"
                                    v-model="reserveNo"
                                /></div>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="予約日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-model="formatedReserveDate"
                                    @focus="focusDate(applicationDate)"
                                    @keyup.delete="deleteKeyUpApplicationDate($event)"
                                    @keyup="applicationDate = formatDate(applicationDate)"
                                    :rules="[rules.string_type,
                                             rules.format_date,
                                             rules.correct_date]"
                                /></div>
                                <div><v-select
                                    class="mr-3 pt-4"
                                    label="予約状況"
                                    :items="reserveSituationData"
                                    item-value="code"
                                    item-text="code_name"
                                    v-model="reserveSituation"
                                /></div>
                                <div><v-select
                                    class="mr-3 pt-4"
                                    :items="golfSelect"
                                    item-value="golf_code"
                                    item-text="golf_name"
                                    v-model="golfCode"
                                    label="ゴルフ場名"
                                ></v-select></div>
                            </v-row>
                            <v-row no-gutters>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="会員No"
                                    v-model="memberNo"
                                /></div>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="代表者（姓）"
                                    v-model="familyName"
                                /></div>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="代表者（名）"
                                    v-model="givenName"
                                /></div>
                                <div><v-text-field
                                    class="mr-3 pt-4"
                                    label="プレー日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-model="formatedPlayDate"
                                    @focus="focusDate(playDate)"
                                    @keyup.delete="deleteKeyUpPlayDate($event)"
                                    @keyup="playDate = formatDate(playDate)"
                                    :rules="[rules.string_type,
                                             rules.format_date,
                                             rules.correct_date]"
                                /></div>
                            </v-row>
                            <v-row no-gutters>
                                <v-checkbox
                                    class="mr-3 selectWidth"
                                    v-model="normal"
                                    label="通常予約"
                                />
                                <v-checkbox
                                    class="mr-3 selectWidth"
                                    v-model="share"
                                    label="シェア予約"
                                />
                                <v-checkbox
                                    class="mr-3 selectWidth"
                                    v-model="completed"
                                    label="未返信メッセージあり"
                                />
                                <v-btn
                                    color="primary"
                                    class="ml-5"
                                    v-on:click="checkValidateSearch"
                                    :disabled="btn[1].isActive"
                                >検索</v-btn>
                                <v-spacer></v-spacer>
                            </v-row>
                        </v-container>
                    </v-form>
                </template>

                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        v-if="item.reserve_no"
                        @click="openModal(item)"
                        :disabled="btn[2].isActive"
                        >詳細</v-btn>
                </template>
                <template v-slot:[`item.companion`]="{ item }">
                    <div v-if="item.reserve_situation==4" class="isCancell">登録</div>
                    <v-btn
                        text
                        color="primary"
                        v-else-if="item.reserve_no"
                        @click="openCompanionModal(item)"
                        :disabled="btn[3].isActive"
                        >登録</v-btn>
                </template>
            </v-data-table>

            <ReserveDetailModal
                ref="Modal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                @refresh-event="getReserveList">
            </ReserveDetailModal>
            <RequestDetailModal
                ref="RequestModal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                @refresh-event="getReserveList">
            </RequestDetailModal>
            <ChangeVisited
                ref="CompanionDialogView"
                @close-companion="closeCompanionModal"
            />

        </v-card>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        ></v-pagination>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
// モーダル
import ReserveDetailModal from './modal/ReserveDetail';
import RequestDetailModal from './modal/ReserveRequestDetail';
import ChangeVisited from './modal/ChangeVisited';

// mixin
import { utilityMixin } from '../../mixins/utility';

// graphql
import { GET_RESERVE_LIST_BY_CONDITION, GET_RESERVE_LIST } from '@/constants/reserve';

export default {
    components: {
        CardTitle,
        ReserveDetailModal,
        RequestDetailModal,
        ChangeVisited
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            maxRows: 10,
            begin_row: 0,
            limit_rows: 10,
            reserveNo: '',
            applicationDate: '',
            reserveSituation: '',
            memberNo: '',
            familyName: '',
            givenName: '',
            playDate: '',
            golfCode: '',
            normal: false,
            share: false,
            completed: false,
            // データテーブルに渡す値
            desserts: [],
            result: '',
            resultText: '',
            // データテーブルの見出し要素
            headers: [
                { text: 'プレー日', sortable: false, value: 'play_date' },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                { text: '予約種別', value: 'reserve_type_name', sortable: false },
                { text: '代表者', align: 'center', value: 'full_name', sortable: false },
                { text: '予約状況', align: 'center', value: 'reserve_situation_name', sortable: false },
                { text: '枠数', align: 'center', value: 'cell_number', sortable: false },
                { text: '人数', align: 'center', value: 'play_number', sortable: false },
                { text: '詳細', align: 'center', value: 'detail', sortable: false },
                { text: '来場実績登録', align: 'center', value: 'companion', sortable: false }
            ],
            // 生年月日の日付格納用
            date: null,
            // データ格納用
            reserveSituationData: [],
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // モーダルウィンドウの状態
            dialog: false,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            // エラーメッセージ
            error: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '詳細', isActive: true },
                { element_id: '003', element_name: '登録', isActive: true }
            ],
            vue_id: 'SCR0015',
            // ゴルフ場セレクトボックス
            golfSelect: [],
            originalData: [],
            detailInfo: {
                reserve_no: '',
                dialog: true
            },
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        // クラシックの場合
        if (process.env.VUE_APP_NAME === 'hcgc') {
            this.headers[1].text = 'スタート時間';
            this.headers[1].value = 'play_start';
        }
        this.applicationDate = await this.getToday();
        await this.initialize();
        this.$store.commit('loading/setIsLoading', false);
    },
    computed: {
        formatedReserveDate: {
            get () {
                return this.applicationDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.applicationDate = value;
            }
        },
        formatedPlayDate: {
            get () {
                return this.playDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.playDate = value;
            }
        }
    },
    methods: {
        /** --------------------------------------------
         * 初期表示
         * ------------------------------------------- */
        async initialize () {
            try {
                await this.$apollo
                    .query({
                        query: GET_RESERVE_LIST,
                        fetchPolicy: 'no-cache',
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            reserve_no: this.reserveNo,
                            application_date: this.applicationDate,
                            reserve_situation: this.reserveSituation,
                            member_no: this.memberNo,
                            family_name: this.familyName,
                            given_name: this.givenName,
                            play_date: this.playDate,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows,
                            normal: this.normal,
                            share: this.share,
                            message_completed: this.completed,
                            vue_id: this.vue_id,
                            element_id: ''
                        }
                    })
                    .then(res => {
                        // ログイン情報
                        this.admin = res.data.getReserveListByAdmin.adminInfo;
                        // ゴルフ場セレクトボックス
                        this.golfSelect = res.data.getReserveListByAdmin.golfCourseSelectList;
                        this.golfCode = this.golfSelect[0].golf_code;
                        this.reserveSituationData = res.data.getReserveListByAdmin.codeList;
                        this.reserveSituationData.unshift({ code: '', code_name: '' });
                        // ステータスが受付のものは削除
                        this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '1');
                        // ステータスが来場済みのものは削除 2020/12/18
                        this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '3');
                        // 権限取得
                        let opeList = res.data.getReserveListByAdmin.operationAccessList;
                        for (let list of opeList) {
                            this.btn.forEach(el => {
                                if (list.element_id === el.element_id) {
                                    if (list.element_control === 0) {
                                        el.isActive = true;
                                    } else {
                                        el.isActive = false;
                                    }
                                }
                            });
                        };
                        const count = res.data.getReserveListByAdmin.count;
                        this.pageCount = Math.ceil(count / this.maxRows);
                        // 予約リスト取得
                        this.desserts = res.data.getReserveListByAdmin.reserveList;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
        * 予約一覧情報を取得
        * -------------------------------------------- */
        async getReserveList () {
            try {
                await this.$apollo
                    .query({
                        query: GET_RESERVE_LIST_BY_CONDITION,
                        fetchPolicy: 'no-cache',
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golfCode,
                            reserve_no: this.reserveNo,
                            application_date: this.applicationDate,
                            reserve_situation: this.reserveSituation,
                            member_no: this.memberNo,
                            family_name: this.familyName,
                            given_name: this.givenName,
                            play_date: this.playDate,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows,
                            normal: this.normal,
                            share: this.share,
                            message_completed: this.completed
                        }
                    })
                    .then(res => {
                        const count = res.data.getReserveListByCondition.count;
                        this.pageCount = Math.ceil(count / this.maxRows);
                        this.desserts = res.data.getReserveListByCondition.ReserveList;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 予約詳細を開く処理
         * ---------------------------------------------- */
        openModal: function (data) {
            this.detailInfo.reserve_no = data.reserve_no;
            this.detailInfo.member_no = data.member_no;
            if (data.reserve_type === 3) {
                this.$refs.RequestModal.openModal();
            } else {
                this.$refs.Modal.openModal();
            }
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        checkValidateSearch () {
            if (this.$refs.form.validate()) {
                this.clickSearch();
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        clickSearch: function () {
            this.page = 1;
            this.begin_row = 0;
            this.getReserveList();
        },
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * this.maxRows - this.maxRows;
            this.getReserveList();
        },
        /** ----------------------------------------------
         * 来場実績モーダルを開く処理
         * ---------------------------------------------- */
        openCompanionModal (data) {
            if (this.dialog) return;
            this.dialog = true;
            this.$refs.CompanionDialogView.OpenDialog(data.reserve_no, true);
        },
        /** ----------------------------------------------
         * 来場実績モーダルを閉じる処理
         * ---------------------------------------------- */
        closeCompanionModal () {
            this.dialog = false;
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpApplicationDate (event) {
            this.applicationDate = this.formatDate(this.applicationDate);
            this.applicationDate = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpPlayDate (event) {
            this.playDate = this.formatDate(this.playDate);
            this.playDate = this.deleteKeyDelete(event);
        }
    }
};
</script>

<style scoped>
.selectWidth {
    width: 200px;
}
.isCancell {
    color: #cccccc !important;
}
</style>
